/* ============================================================
   Navigation model — UI-1 (edbdcb80, Artem 2026-08-26: «футер не
   подходит для всех вкладок, их может становиться больше и больше,
   и уже сейчас едет верстка из-за этого»).

   Single source of truth for top-level tabs. The navbar used to
   hard-code inline links with flex-wrap, so every new tab wrapped
   the sticky header into stacked rows and broke the 56px layout.
   Navigation is now data-driven: adding a tab = one entry here.
   Consumers:
     - Navbar inline row (desktop ≥768px, overflow-x scroll)
     - NavDrawer vertical list (mobile <768px, hamburger)
   Pure module — no React, unit-tested in tests/navigation.test.ts.
   ============================================================ */

import type { Page } from '../routing';

export interface NavItem {
  page: Page;
  label: string;
  icon: string;
}

/** Session shape the nav model needs (subset of AuthResponse). */
export interface NavSession {
  authenticated: boolean;
  role: string | null;
}

/**
 * Ordered top-level tabs. Role-gated entries stay in their fixed
 * position so the tab order never reshuffles when the session
 * changes (favorites only for signed-in users, admin only for the
 * Admin role — same visibility rules as the pre-UI-1 navbar).
 */
export function navItems(session: NavSession): NavItem[] {
  const items: NavItem[] = [
    { page: 'quote', label: 'Заказать печать', icon: '🖨' },
    { page: 'shop', label: 'Магазин', icon: '🛍' },
    { page: 'providers', label: 'Исполнители', icon: '🤝' },
    { page: 'cart', label: 'Корзина', icon: '🛒' },
    { page: 'orders', label: 'Мои заказы', icon: '📦' },
  ];
  if (session.authenticated) {
    items.push({ page: 'favorites', label: 'Избранное', icon: '❤️' });
  }
  items.push({ page: 'provider', label: 'Кабинет исполнителя', icon: '🧰' });
  if (session.role === 'Admin') {
    items.push({ page: 'admin', label: 'Админ', icon: '⚙️' });
  }
  return items;
}
